export default __webpack_public_path__ + "static/media/review13.fca81b33.jpg";